// SimpleTabs.js
import React from "react";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import CustomTab from "./TabComponent";
import CustomTabPanel from "./TabPanelComponent";
import { a11yProps } from "./Utils";
import MyProfileForm from "../MyProfile/MyProfileForm";
import useStyles from "../../../styles";
import BulkPasswordChange from "./BulkPasswordChange/BulkPasswordChange";
import BulkExamLogout from "./BulkExamLogout/BulkExamLogout";
import ExtraTime from "./ExtraTime/ExtraTime";
import RestartExam from "./RestartExam/RestartExam";
import TransferQuestion from "./TransferQuestion/TransferQuestion";


export default function SettingsMain({ fetchDataFromAPI }) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const items = [
    { id: 1, label: "Center Details" },
    { id: 2, label: "Password Change" },
    { id: 3, label: "Relogin Logout" },
     { id: 4, label: "Extra Time" },
    { id: 5, label: "Restart Exam" },
    { id: 6, label: "Transfer Question" },
  ];
  const items1 = [
    { id: 1, label: <MyProfileForm fetchDataFromAPI={fetchDataFromAPI} /> },
    { id: 2, label: <BulkPasswordChange /> },
    { id: 3, label: <BulkExamLogout /> },
     { id: 4, label: <ExtraTime /> },
    { id: 5, label: <RestartExam /> },
    { id: 6, label: <TransferQuestion /> },
  ];

  return (
    <div className={`${classes.p2} ${classes.pb0} ${classes.pt1}`}>
      <div className={classes.root}>
        <AppBar position="static">
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="none"
            aria-label="simple tabs example"
            variant="scrollable"
            scrollButtons="auto"
          >
            {items.map((item) => (
              <CustomTab
                className={classes.tab}
                key={item.id}
                label={item.label}
                id={item.id}
                index={item.id - 1}
                onChange={handleChange}
                {...a11yProps(item.id)}
              />
            ))}
          </Tabs>
        </AppBar>
        {items1.map((item, index) => (
          <CustomTabPanel
            key={item.id}
            value={value}
            index={index}
            id={item.id}
          >
            {item.label}
          </CustomTabPanel>
        ))}
      </div>
    </div>
  );
}
